import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../../fromTeens/FromTeens.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/swiper-bundle.css";
import { Navigation, Pagination } from "swiper";
import teenOne from "../../../assets/images/instruc_1.png";
import { RatingStart } from "../../../assets/icons/RatingStart";
export const GuideTestimonials = ({ textWhite, heading, content }) => {
  const currentUrl = window.location.href;
  const containsSite2 = currentUrl.includes("site-two");
  return (
    <>
      <div
        className="keyzi_FromTeens--wrapper keyzi_guideTestimonials--wrapper"
        id="testimonial_section"
      >
        <Container>
          <div
            className={
              containsSite2
                ? "keyzi_FromTeensSiteTwo--inner"
                : "keyzi_FromTeens--inner"
            }
          >
            <h2 className={textWhite && textWhite}>
              {heading}
            </h2>
            <div className="swiper--fromTeens">
              <Swiper
                slidesPerView={5}
                spaceBetween={10}
                autoplay={true}
                navigation={{
                  nextEl: ".custom-next",
                  prevEl: ".custom-prev",
                }}
                pagination={{
                  clickable: true,
                }}
                modules={[Navigation, Pagination]}
                breakpoints={{
                  1400: {
                    slidesPerView: 5,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  640: {
                    slidesPerView: 1,
                  },
                  0: {
                    slidesPerView: 1,
                  },
                }}
                className="mySwiper"
              >
                { content?.map((e, index) => (
                    <SwiperSlide key={index}>
                      <div className="fromTeens--card">
                        <div className="card-header">
                          <img
                            src={`https://keyzi.com.au/keyzi-admin/public${e.image}`}
                            alt={e?.image_attribute}
                            className="img-fluid"
                          />
                          <div className="cardHeader-content">
                            <h6>{e?.title}</h6>
                            <RatingStart
                              dynamicColor={
                                containsSite2 ? "#FFCE00" : "#252237"
                              }
                            />
                          </div>
                        </div>
                        <div className="card-body">
                          <p>{e?.description || "content"}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
              </Swiper>
              <div className="custom-next"></div>
              <div className="custom-prev"></div>
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};
